
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-slate-900/80 to-black/90 border-t border-white/10">
      <div className="container mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl text-white tracking-wide mb-4 font-bold" style={{ fontFamily: '"Orbitron", monospace' }}>
              Sentronics
            </h3>
            <p className="text-white/70 mb-6 leading-relaxed">
              Your premier technology partner in Hong Kong, specializing in technology R&D, transfer, and OEM customization. Bridging global innovation with market opportunities.
            </p>
            <div className="text-white/60 text-sm">
              <p className="mb-2">
                <strong className="text-white/80">Sentronics Solution Limited</strong>
              </p>
              <p className="leading-relaxed mb-2">
                Unit 89, 3/F., Yau Lee Centre<br />
                No.45, Hoi Yuen Road, Kwun Tong<br />
                Hong Kong
              </p>
              <p className="mb-1">
                <i className="ri-phone-line mr-2"></i>+852 5798 7927
              </p>
              <p className="mb-1">
                <i className="ri-mail-line mr-2"></i>info@sentronics.hk
              </p>
              <p>
                <i className="ri-global-line mr-2"></i>www.sentronics.hk
              </p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-white/70 text-sm">Technology R&D & Transfer</span>
              </li>
              <li>
                <span className="text-white/70 text-sm">OEM/ODM Customization</span>
              </li>
              <li>
                <span className="text-white/70 text-sm">Technology Consulting</span>
              </li>
              <li>
                <span className="text-white/70 text-sm">Market Integration</span>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/" className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer">
                  Technology Focus
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Technology Areas */}
          <div>
            <h4 className="text-white font-semibold mb-6">Technology Areas</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-white/70 text-sm">Oil & Gas</span>
              </li>
              <li>
                <span className="text-white/70 text-sm">Smart Monitoring</span>
              </li>
              <li>
                <span className="text-white/70 text-sm">Software Development</span>
              </li>
              <li>
                <span className="text-white/70 text-sm">Intelligent Manufacturing</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-white/60 text-sm">
              © {currentYear} Sentronics Solution Limited. All rights reserved.
            </div>
            <div className="flex items-center gap-6">
              <div className="text-white/60 text-sm">Connecting Innovation • Technology • Future</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
